const SpecialOffer = ({ width = 14, height = 14, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="none" {...props}>
    <mask
      id="a"
      width={14}
      height={14}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path fill="#D9D9D9" d="M14 0v14H0V0z" />
    </mask>

    <g mask="url(#a)">
      <path
        fill="#C00"
        d="m5.688 12.483-4.171-4.17a1.17 1.17 0 0 1-.35-.831 1.17 1.17 0 0 1 .35-.832l5.148-5.148a1.152 1.152 0 0 1 .817-.335h4.185c.32 0 .595.114.824.342.228.229.342.504.342.824V6.52a1.208 1.208 0 0 1-.35.831l-5.148 5.133a1.08 1.08 0 0 1-.393.256 1.206 1.206 0 0 1-.868 0 1.094 1.094 0 0 1-.386-.256Zm3.645-8.691c0 .243.085.45.256.62.17.17.376.255.62.255.242 0 .449-.085.62-.256a.844.844 0 0 0 .254-.62.844.844 0 0 0-.255-.62.844.844 0 0 0-.62-.254.844.844 0 0 0-.62.255.844.844 0 0 0-.255.62Z"
      />
    </g>
  </svg>
);

export default SpecialOffer;
